import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { getBlackoutPeriodActive, toggleBlackoutPeriod } from "../../../redux/actions/UtilityActions";
import Page from "../../common/Page";
import CashOutBlackoutCard from "./CashOutBlackoutCard";
import QuarterlyAccrualCard from "./QuarterlyAccrualCard";
import CompOutAccrualCard from "./CompOutAccrualCard";

const AdminFunctionsPage = (props) => {
  const toggleBlackout = () => {
    return props.toggleBlackoutPeriod();
  };

  useEffect(() => {
    const temp = async () => await props.getBlackoutPeriodActive();
    temp();
  });

  return (
    <Page pageTitle="Admin Tools">
      <Container fluid>
        <Row>
          <Col>
            <CashOutBlackoutCard blackedOut={props.blackedOut} toggleBlackout={toggleBlackout} />
          </Col>
        </Row>
        <Row>
          <Col>
            <QuarterlyAccrualCard />
          </Col>
        </Row>
        <Row>
          <Col>
            <CompOutAccrualCard />
          </Col>
        </Row>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    blackedOut: state.blackoutPeriod,
  };
};

const mapDispatchToProps = {
  getBlackoutPeriodActive,
  toggleBlackoutPeriod,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminFunctionsPage);
